module.exports = "<div style=\"height: 100%;width: 100%;overflow: hidden\">\n  Top Image\n</div>\n"